import { useRef, useLayoutEffect } from "react";
import { normalizeRows } from "./normalizeRows.js";
import { calculateNodeHeight } from "./calculateNodeHeight.js";
import { getSizingData } from "./getSizingData.js";
function useAutoHeight(ref, minRows, maxRows) {
  const heightRef = useRef(0);
  const [normalizedMinRows, normalizedMaxRows] = normalizeRows(minRows, maxRows);
  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    const nodeSizingData = getSizingData(node);
    if (!nodeSizingData) {
      return;
    }
    const height = calculateNodeHeight({
      sizingData: nodeSizingData,
      value: node.value || node.placeholder || "x",
      minRows: normalizedMinRows,
      maxRows: normalizedMaxRows
    });
    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty("height", `${height}px`, "important");
    }
  });
}
export {
  useAutoHeight
};
//# sourceMappingURL=useAutoHeight.js.map
